import { ContractCurrency } from './contract-currency';

export enum ExtensionStatus {
    Draft = 0,
    InProgress = 1,
    AwaitingApproval = 2,
    Confirmed = 3,
    Declined = 4,
    Failed = 5,
    Cancelled = 6,
}

export interface Extension {
    id: number;
    contractId: number;
    status: ExtensionStatus;
    purchasePrice?: string;
    soldPrice?: string;
    travelPrice?: string;
    overtimePrice?: string;
    costPrice?: string;
    margin?: string;
    weeklyHours?: string;
    description?: string;
    reg?: string;
    account?: string;
    iban?: string;
    swift?: string;
    currency?: string;
    equipment?: string;
    startDate?: Date | string;
    endDate?: Date | string;
    paymentTermsIsKnown: boolean;
    option?: number;
    createdDate?: Date | string;
    contractDetailsCount: number;
    contractCurrency?: ContractCurrency;
}
